import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {NavigationItem} from '../model/navigation-item';
import {TvShopEntertainmentPack} from '../model/tv-shop-entertainment-pack';

@Component({
  selector: 'app-product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrls: ['./product-carousel.component.less'],
  animations: []
})
export class ProductCarouselComponent implements OnInit {
  static LEFT = 23.75;
  static RIGHT = -23.75;

  @Input()
  private _packs: Array<TvShopEntertainmentPack>;
  @Input()
  yIndex: number;

  @Input() isBigTile: boolean;
  @Input() showSubtitle: boolean;
  @Input() showPromoBadge: boolean;

  containerWidth: any;
  vwValue = 0;
  currentlyActiveItem: NavigationItem;
  scrolledTo = 0;
  visibleCarouselItems = 4;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.calculateContainerWidth();
  }

  get packs(): Array<TvShopEntertainmentPack> {
    return this._packs;
  }

  @Input()
  set packs(value: Array<TvShopEntertainmentPack>) {
    this._packs = value;
  }

  calculateContainerWidth() {
    this.containerWidth = ((this._packs.length * 25) - 6) + 'vw';
  }

  public resetCarouselScrolling(): void {
    this.vwValue = 0;
    this.scrolledTo = 0;
    this.currentlyActiveItem = null;
    this.toggleState();
  }

  public resetCarouselScrolling1(): void {
    this.scrolledTo = this._packs.length - this.visibleCarouselItems;
    this.vwValue = this.scrolledTo * ProductCarouselComponent.RIGHT;
    this.currentlyActiveItem = null;
    this.toggleState();
  }


  private activateCarouselScrolling(activatedItem: NavigationItem): void {
    const scrollDirection = this.determineDirection(activatedItem);
    const indexToScrollTo = this.calculateIndexToScrollTo(scrollDirection, activatedItem.x);

    if (indexToScrollTo !== this.scrolledTo) {
      this.scrolledTo = indexToScrollTo;
      this.scroll(scrollDirection);
    }
  }

  public scrollToSelectedPack(activatedItem: NavigationItem): void {
    this.activateCarouselScrolling(activatedItem);
    this.currentlyActiveItem = activatedItem;

    if (activatedItem.x === 0) {
      this.resetCarouselScrolling();
    }

    if (this._packs.length >= this.visibleCarouselItems && activatedItem.x === this._packs.length - 1) {
      this.resetCarouselScrolling1();
    }
  }

  private scroll(vw: number): void {
    this.vwValue += vw;
    this.toggleState();
  }

  private determineDirection(activatedItem: NavigationItem): number {
    let currentActiveIndex;
    if (this.currentlyActiveItem) {
      currentActiveIndex = this.currentlyActiveItem.x;
    } else {
      currentActiveIndex = 0;
    }

    if (activatedItem.x > currentActiveIndex) {
      return ProductCarouselComponent.RIGHT;
    } else if (activatedItem.x < currentActiveIndex) {
      return ProductCarouselComponent.LEFT;
    } else {
      return null;
    }
  }

  private calculateIndexToScrollTo(scrollDirection, selectedProductIndex: number): number {
    let indexToScrollTo = selectedProductIndex;
    if (scrollDirection === ProductCarouselComponent.RIGHT) {
      if (this.scrolledTo + this.visibleCarouselItems > indexToScrollTo) {
        indexToScrollTo = this.scrolledTo;
      }
      if (this.scrolledTo + this.visibleCarouselItems === indexToScrollTo) {
        indexToScrollTo = this.scrolledTo + 1;
      }
    } else {
      if (this.scrolledTo < indexToScrollTo) {
        indexToScrollTo = this.scrolledTo;
      }
    }
    return indexToScrollTo;
  }

  private toggleState(): void {
    this.el.nativeElement.querySelector('div').style.transform = 'translate3d(' + this.vwValue + 'vw, 0, 0)';
  }
}
